import { BaseModel } from 'paliari-js-utils'

const attributes = {
  nome: '',
}

class Bairro extends BaseModel {
  constructor(obj) {
    super(attributes, obj)
  }
}

export default Bairro
